
import { Signal } from "@angular/core";
import { StoreBatchWeighing } from "./model/registrations/store-batch-weighing";
import { updateAllObjectsInMap } from "../../functions/store-update-map.function";


export const updateBatchWeighings = (
  newItems: Partial<StoreBatchWeighing>[],
  dataFromStore: Signal<Record<string, StoreBatchWeighing>>

) => {
  const updatedMap = updateAllObjectsInMap(newItems, dataFromStore);
  const newState = {
    batchWeighings: updatedMap as Record<string, StoreBatchWeighing>,
  };
  return newState;
};
